import React from 'react';
import Day from './Day';
import './Week.css';
import { clearSelection, checkCircles } from './filter';

function getCurrentWeek() {
    // get date of the current sunday
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    console.log(today);
    var day = today.getDay();
    var date = today.getDate();
    today = new Date(today.setDate(date - day));
    today = today.toISOString().split('T')[0];
    return today;
}

// function updateWeek() {
//     // check if DOM is loaded
//     if (document.getElementById("currentSunDate") == null) {
//         var startingDate = getCurrentWeek();
//         var currentWeek = [];
//         var currentSunDate = new Date(startingDate);
//         for (var i = 0; i < 7; i++) {
//             var day = currentSunDate.getDay();
//             var date = currentSunDate.getDate();
//             var month = currentSunDate.toLocaleString('default', { month: 'short' });
//             var dayName = currentSunDate.toLocaleString('default', { weekday: 'short' });
//             var currentDate = month + " " + date;
//             var today = new Date();
//             var todayDate = today.getDate();
//             var todayMonth = today.toLocaleString('default', { month: 'short' });
//             var todayDate = todayMonth + " " + todayDate;
//             var classToday = "";
//             if (currentDate == todayDate) {
//                 classToday = "today";
//             }
//             currentWeek.push(
//                 <Day day={dayName} date={date} class={classToday} />
//             );
//             currentSunDate.setDate(currentSunDate.getDate() + 1);
//         }
//         return currentWeek;
//     } else {
//         return getWeek();
//     }
// }

function getWeek(start) {
    // get the current week, sun - sat and create a day element for each day
    var currentWeek = [];
    var currentSunDate = new Date(start + "T00:00:00");
    // make sure the date is a sunday
    var day = currentSunDate.getDay();
    var date = currentSunDate.getDate();
    currentSunDate = new Date(currentSunDate.setDate(date - day));
    currentSunDate.setHours(0, 0, 0, 0);
    for (var i = 0; i < 7; i++) {
        var date = currentSunDate.getDate();
        var month = currentSunDate.toLocaleString('default', { month: 'short' });
        var dayName = currentSunDate.toLocaleString('default', { weekday: 'short' });
        // format date to yyyy-mm-dd
        var fulldate = currentSunDate.toISOString().split('T')[0];
        var currentDate = month + " " + date;
        var today = new Date();
        var todayDate = today.getDate();
        var todayMonth = today.toLocaleString('default', { month: 'short' });
        todayDate = todayMonth + " " + todayDate;
        var classToday = "";
        if (currentDate === todayDate) {
            classToday = "today ";
        }
        currentWeek.push(
            <Day day={dayName} date={date} fulldate={fulldate} class={classToday} />
        );
        // Q: why are the components not recreated when this function is called?
        // A: because the state is not updated
        currentSunDate.setDate(currentSunDate.getDate() + 1);
    }
    return currentWeek;
}

export function clearSelected() {
    clearSelection();
    // clear the selected day
    var selected = document.getElementsByClassName("day-selected");
    if (selected.length > 0) {
        selected[0].classList.remove("day-selected");
    }
}

// function getPastWeek() {
//     // change currentSunDate to the previous week
//     var currentSunDate = this.state.currentSunDate;
//     var today = new Date(currentSunDate);
//     today.setDate(today.getDate() - 7);
//     today = today.toISOString().slice(0, 10);

//     this.state.currentSunDate = today;
// }

// function getNextWeek() {
//     // change currentSunDate to the next week
//     var currentSunDate = this.state.currentSunDate;
//     var today = new Date(currentSunDate);
//     today.setDate(today.getDate() + 7);
//     today = today.toISOString().slice(0, 10);

//     this.state.currentSunDate = today;
// }

function test() {
    console.log("rendered");
}

class Week extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSunDate: getCurrentWeek()
        }
    }
    getPastWeek = () => {
        // change currentSunDate to the previous week
        var currentSunDate = this.state.currentSunDate;
        var today = new Date(currentSunDate);
        today.setDate(today.getDate() - 7);
        today = today.toISOString().slice(0, 10);
        this.setState({ currentSunDate: today }, () => {
            checkCircles();
        });
    }
    getNextWeek = () => {
        // change currentSunDate to the next week
        var currentSunDate = this.state.currentSunDate;
        var today = new Date(currentSunDate);
        today.setDate(today.getDate() + 7);
        today = today.toISOString().slice(0, 10);
        // this.setState({ currentSunDate: today });
        // Q: How to call checkCircles() after component is re-rendered?
        // A: use .then() after setState
        // Q: It is saying "Cannot read properties of undefined (reading 'then')"
        // A: because setState is not a function, it is a method of the React.Component class
        // Q: How do i call a callback function after setState then if it is not a function?
        this.setState({ currentSunDate: today }, () => {
            checkCircles();
        });
    
    }
    updateWeek = () => {
        console.log(getWeek(this.state.currentSunDate));
        return getWeek(this.state.currentSunDate);
    }
    updateMonth = () => {
        // update the month
        var currentSunDate = this.state.currentSunDate;
        currentSunDate = new Date(currentSunDate);
        var month = currentSunDate.toLocaleString('default', { month: 'long' });
        return <h1 className='month' id="month">{month}</h1>;
    }
    render() {
        return (
            <header className="App-header">
                {this.updateMonth()}
                {/* <Week /> */}
                <div id="week-calendar">
                    {test()}
                    <span className="arrow arrow-left" onClick={this.getPastWeek} ></span>
                    {/* <Day day="sun" date="5" />
                    <Day day="mon" date="6" />
                    <Day day="tue" date="7" />
                    <Day day="wed" date="8" />
                    <Day day="thu" date="9" class="today" />
                    <Day day="fri" date="10" />
                    <Day day="sat" date="11" /> */}
                    {this.updateWeek()}
                    <span className="arrow arrow-right" onClick={this.getNextWeek} ></span>
                </div>
            </header>
        );
    }
}
export default Week;